import { combineReducers } from 'redux';
import billingAddress from './billingAddress/billingAddressReducer';
import limits from './limits/limitsReducer';
import user from './user/userReducer';
import { reducer as details } from './detailsModule';

export default combineReducers({
	billingAddress,
	details,
	limits,
	user,
});
